import React, { Component } from 'react'
import {
  Button,
  Dimmer,
  Label,
  Loader,
  Modal,
  Segment } from 'semantic-ui-react'

import { QueryWrap } from '../error_handling'
import { QueryFeedLog } from '../../graphql'

import { ArticlePreview } from '../../probish/ArticlePreview'


class TerminalOutput extends Component {
  constructor (props) {
    super(props)
    this.state = { modal_preview_url: null }
  }

  handlePreview (logline) {
    this.setState({modal_preview_url: logline.preview_url})
  }

  handleCloseModal () {
    this.setState({modal_preview_url: null})
  }

  renderModalPreview () {
    const { modal_preview_url } = this.state
    
    return (
      <Modal
        className='terminal-preview-modal'
        open={modal_preview_url}
        size='small'
        onClose={ () => this.handleCloseModal()}
        closeIcon
        dimmer={true}
      >
        <Label size='small' attached='top left' className='terminal-preview-modal-corner'>preview</Label>
        <Modal.Header className='terminal-preview-modal-header'></Modal.Header>
        <Modal.Content>
          <ArticlePreview preview_url={modal_preview_url} />
        </Modal.Content>
      </Modal>
    )
  }

  render () {
    const {loading, output, lines, loglines} = this.props

    let colored_output = output
    colored_output = colored_output && colored_output.replace(/✔/g, '<span class="green-check">✔</span>')
    colored_output = colored_output && colored_output.replace(/⨯/g, '<span class="red-cross">⨯</span>')

    return (
      [
        this.renderModalPreview(),
        (
          <Segment className='apis3push-terminal-output'>
            { loading ? (
              <div>
                <Dimmer active inverted>
                  <Loader>Loading</Loader>
                </Dimmer>
                <div className='textarea'>&nbsp;</div>
              </div>
            ) : (
                lines ? (
                  <div className='lines' ref={(el) => { this.lines = el; }} >
                    { lines.map((line, i) => (
                      <div className='line' key={i}>{line}</div>
                    ))}
                  </div>
                ) : loglines ? (
                  <div className='lines' ref={(el) => { this.lines = el; }} >
                      { loglines.map((logline, i) => (
                        <div className={`line ${logline.ok ? 'is-ok' : 'is-not-ok'}`} key={i}>
                        {
                          [
                            logline.line,
                            (logline.preview_url ?
                              (<Button size='tiny'
                                className='terminal-preview-button'
                                key={i}
                                onClick={() => {this.handlePreview(logline)}}>preview
                                </Button>
                              ) : null)
                          ]
                        }
                        </div>
                      )) }
                  </div>
                ) : (
                  <div className='textarea' dangerouslySetInnerHTML={{__html: colored_output}} ref={(el) => { this.textarea = el; }} />
                )
            )}
          </Segment>
        )
      ]
    )
  }


  componentDidUpdate (prevProps, prevState) {
    if (this.props.bottom_scrolled) {
      this.scrollToBottom()
    }
  }

  componentDidMount () {
    if (this.props.bottom_scrolled) {
      this.scrollToBottom()
    }
  }

  scrollToBottom () {
    const el = this.lines || (this.textarea && this.textarea.ref)
    if (el) {
      const maxScrollTop = el.scrollHeight - el.clientHeight
      el.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0
      el.classList.add('smooth-scrolling')  // smooth scrolling after initial render
    }
  }
}


class FeedLog extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  setLoadingState (newLoading) {
    const { loading } = this.state
    if (loading !== newLoading) {
      this.setState({loading: newLoading})
    }
  }

  renderContent (lines='', loglines='', refetch=undefined) {
    const { loading } = this.state
    return this.renderLog(loading, lines, loglines, refetch)
  }

  renderLog (loading, lines='', loglines='', refetch=undefined) {
    return (
      <div className='feedlog'>
        <Button icon='refresh' disabled={loading} title='Aktualisieren'
          size='mini' onClick={() => {
            this.setLoadingState(true)
            return refetch()
          }} />
        <TerminalOutput loading={loading} lines={lines} loglines={loglines} bottom_scrolled={true} />
      </div>
    )
  }

  render () {
    const { pollAfterFinish, onStopPollAfterFinish } = this.props
    const vars = {
      auid: this.props.auid,
      feed_id: this.props.feed_id,
      with_preview_url: true
    }
    return (
      <QueryWrap query={QueryFeedLog} variables={vars} pollInterval={(pollAfterFinish ? 10000 : 30000)}>
        {({ loading, error, data: {getFeedLog = {} }, refetch }) => {
          this.setLoadingState(loading)
          if (loading) return this.renderContent()
          if (error) return `Error!: ${error}`

          const lines = getFeedLog ? getFeedLog.lines : []
          const loglines = getFeedLog ? getFeedLog.loglines : []
          const hasLoglines = (loglines && loglines.length > 0)
          if ( pollAfterFinish && ((lines && lines.length > 0) || hasLoglines) ) {
            // Stop polling if results fetched
            onStopPollAfterFinish()
          }

          // Show some feedback for the user if no logs there yet
          if (!hasLoglines) return this.renderLog(true)
          return this.renderContent(lines, loglines, refetch)
        }}
      </QueryWrap>
    )
  }
}

//export default FeedLog
export { FeedLog, TerminalOutput }


// WEBPACK FOOTER //
// ./src/components/push_apis/FeedLog.js